import { render } from "./index.vue?vue&type=template&id=3c1be941"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "D:\\DevelopmentWork\\app\\JGJWork\\vue\\t3custom_2pos\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__